"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var noLocaleData = require("i18next-icu/locale-data/no");
exports.default = noLocaleData;
//# sourceMappingURL=no.js.map